// src/util/tenantBranding.js
export async function loadTenantBranding(themeData) {
  try {
    // console.log("Branding: ", themeData);
    // Detect tenant by subdomain (e.g., acme.multiapp.ac)
    // const subdomain = window.location.hostname.split(".")[0];

    // 🔹 Option 1: Fetch from API
    // const res = await fetch(`/api/tenant/config?tenant=${subdomain}`);
    // const data = await res.json();

    // Fallbacks if API not available
    const favicon = themeData?.branding?.faviconUrl || "/multiapp-favicon.ico";
    const logo192 = themeData?.logo192 || "/logo192.png";
    const logo512 = themeData?.logo512 || "/logo512.png";
    const name = themeData?.branding?.appName || "MultiApp";
    const themeColor = themeData?.themeColor || "#000000";

    // ✅ Set favicon
    let link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = favicon;
    document.head.appendChild(link);

    // ✅ Set app title
    document.title = name;

    // ✅ Set theme color
    let theme = document.querySelector("meta[name='theme-color']");
    if (!theme) {
      theme = document.createElement("meta");
      theme.name = "theme-color";
      document.head.appendChild(theme);
    }
    theme.content = themeColor;

    // ✅ Dynamically override manifest.json
    const manifest = {
      short_name: name,
      name: name,
      icons: [
        {
          src: favicon,
          sizes: "64x64 32x32 24x24 16x16",
          type: "image/x-icon",
        },
        { src: logo192, sizes: "192x192", type: "image/png" },
        { src: logo512, sizes: "512x512", type: "image/png" },
      ],
      start_url: ".",
      display: "standalone",
      theme_color: themeColor,
      background_color: "#ffffff",
    };

    const blob = new Blob([JSON.stringify(manifest)], {
      type: "application/json",
    });
    const manifestURL = URL.createObjectURL(blob);

    let manifestTag = document.querySelector("link[rel='manifest']");
    if (!manifestTag) {
      manifestTag = document.createElement("link");
      manifestTag.rel = "manifest";
      document.head.appendChild(manifestTag);
    }
    manifestTag.setAttribute("href", manifestURL);

    // console.log(`✅ Branding applied for tenant: ${subdomain}`);
  } catch (err) {
    console.error("❌ Failed to load tenant branding:", err);
  }
}
